import api from './api';
import {
  HistorieResponse,
  SchwachstelleVersionList,
  SchwachstelleVersion,
  AuditVersionList,
  AuditVersion,
} from '../types';

export const historieService = {
  // --- Generisches Änderungsprotokoll ---
  getHistorie: async (entitaetTyp: string, entitaetId: number): Promise<HistorieResponse> => {
    const response = await api.get(`/historie/${entitaetTyp}/${entitaetId}`);
    return response.data;
  },

  // --- Schwachstelle-Versionen ---
  getSchwachstelleVersionen: async (schwachstelleId: number): Promise<SchwachstelleVersionList[]> => {
    const response = await api.get(`/historie/schwachstellen/${schwachstelleId}/versionen`);
    return response.data;
  },

  getSchwachstelleVersion: async (schwachstelleId: number, versionNummer: number): Promise<SchwachstelleVersion> => {
    const response = await api.get(`/historie/schwachstellen/${schwachstelleId}/versionen/${versionNummer}`);
    return response.data;
  },

  restoreSchwachstelleVersion: async (schwachstelleId: number, versionNummer: number): Promise<SchwachstelleVersion> => {
    const response = await api.post(`/historie/schwachstellen/${schwachstelleId}/versionen/${versionNummer}/wiederherstellen`);
    return response.data;
  },

  // --- Audit-Versionen ---
  getAuditVersionen: async (auditId: number): Promise<AuditVersionList[]> => {
    const response = await api.get(`/historie/audits/${auditId}/versionen`);
    return response.data;
  },

  getAuditVersion: async (auditId: number, versionNummer: number): Promise<AuditVersion> => {
    const response = await api.get(`/historie/audits/${auditId}/versionen/${versionNummer}`);
    return response.data;
  },

  restoreAuditVersion: async (auditId: number, versionNummer: number): Promise<AuditVersion> => {
    const response = await api.post(`/historie/audits/${auditId}/versionen/${versionNummer}/wiederherstellen`);
    return response.data;
  },
};
